export const scanners = [
    {
        id: 0, name: 'Corporate High Yield',
        bondFields: {
            endDate: '20281231',
            startDate: '20230101',
            yieldMin: 7,
            yieldMax: 12
        },
        filters: {
            instrument: 'BOND',
            locations: 'BOND.US',
            scanCode: 'HIGH_BOND_ASK_YIELD_ALL',
            secType: 'BOND',
            filters: [
                {
                    'code': 'maturityDateAbove',
                    'value': '20230101'
                },
                {
                    'code': 'maturityDateBelow',
                    'value': '20281231'
                },
                {
                    'code': 'bondAskYieldAbove',
                    'value': 7
                },
                {
                    'code': 'bondAskYieldBelow',
                    'value': 12
                },
                {
                    'code': 'moodyRatingAbove',
                    'value': 'C'
                },
                {
                    'code': 'moodyRatingBelow',
                    'value': 'Aaa'
                },
                {
                    'code': 'spRatingAbove',
                    'value': 'B-'
                },
                {
                    'code': 'spRatingBelow',
                    'value': 'AAA'
                },
                {
                    'code': 'currencyLike',
                    'value': 'USD'
                }
            ]
        }
    },
    {
        id: 1, name: 'Corporate US 2-3%',
        bondFields: {
            endDate: '20341231',
            startDate: '20240101',
            yieldMin: 2,
            yieldMax: 3
        },
        filters: {
            instrument: 'BOND',
            locations: 'BOND.US',
            scanCode: 'HIGH_BOND_ASK_YIELD_ALL',
            secType: 'BOND',
            filters: [
                {
                    'code': 'maturityDateAbove',
                    'value': '20240101'
                },
                {
                    'code': 'maturityDateBelow',
                    'value': '20341231'
                },
                {
                    'code': 'bondAskYieldAbove',
                    'value': 2
                },
                {
                    'code': 'bondAskYieldBelow',
                    'value': 3
                },
                {
                    'code': 'moodyRatingAbove',
                    'value': 'Baa3'
                },
                {
                    'code': 'moodyRatingBelow',
                    'value': 'Aaa'
                },
                {
                    'code': 'spRatingAbove',
                    'value': 'BBB-'
                },
                {
                    'code': 'spRatingBelow',
                    'value': 'AAA'
                },
                {
                    'code': 'currencyLike',
                    'value': 'USD'
                }
            ]
        }
    },
    {
        id: 2, name: 'Top Munis',
        bondFields: {
            endDate: '20311231',
            startDate: '20220101',
            yieldMin: 1,
            yieldMax: 7
        },
        filters: {
            instrument: 'BOND.MUNI',
            locations: 'BOND.MUNI.US',
            scanCode: 'FAR_MATURITY_DATE',
            secType: 'BOND',
            filters: [
                {
                    'code': 'maturityDateAbove',
                    'value': '20220101'
                },
                {
                    'code': 'maturityDateBelow',
                    'value': '20311231'
                },
                {
                    'code': 'bondAskYieldAbove',
                    'value': 1
                },
                {
                    'code': 'bondAskYieldBelow',
                    'value': 7
                },
                {
                    'code': 'moodyRatingAbove',
                    'value': 'C'
                },
                {
                    'code': 'moodyRatingBelow',
                    'value': 'Aaa'
                },
                {
                    'code': 'spRatingAbove',
                    'value': 'B-'
                },
                {
                    'code': 'spRatingBelow',
                    'value': 'AAA'
                },
                {
                    'code': 'currencyLike',
                    'value': 'USD'
                }
            ]
        }
    },
    {
        id: 3, name: 'Munis Investment Grade',
        bondFields: {
            endDate: '20311231',
            startDate: '20220101',
            yieldMin: 0.5,
            yieldMax: 5
        },
        filters: {
            instrument: 'BOND.MUNI',
            locations: 'BOND.MUNI.US',
            scanCode: 'FAR_MATURITY_DATE',
            secType: 'BOND',
            filters: [
                {
                    'code': 'maturityDateAbove',
                    'value': '20220101'
                },
                {
                    'code': 'maturityDateBelow',
                    'value': '20311231'
                },
                {
                    'code': 'bondAskYieldAbove',
                    'value': 0.5
                },
                {
                    'code': 'bondAskYieldBelow',
                    'value': 5
                },
                {
                    'code': 'moodyRatingAbove',
                    'value': 'Baa3'
                },
                {
                    'code': 'moodyRatingBelow',
                    'value': 'Aaa'
                },
                {
                    'code': 'spRatingAbove',
                    'value': 'BBB-'
                },
                {
                    'code': 'spRatingBelow',
                    'value': 'AAA'
                },
                {
                    'code': 'currencyLike',
                    'value': 'USD'
                }
            ]
        }
    },
    {
        id: 4, name: 'US CDs High Yield',
        bondFields: {
            endDate: '20331231',
            startDate: '20230101',
            yieldMin: 2,
            yieldMax: 12
        },
        filters: {
            instrument: 'BOND.CD',
            locations: 'BOND.CD.US',
            scanCode: 'HIGH_BOND_ASK_YIELD_ALL',
            secType: 'BOND',
            filters: [
                {
                    'code': 'maturityDateAbove',
                    'value': '20230101'
                },
                {
                    'code': 'maturityDateBelow',
                    'value': '20331231'
                },
                {
                    'code': 'bondAskYieldAbove',
                    'value': 2
                },
                {
                    'code': 'bondAskYieldBelow',
                    'value': 12
                },
                {
                    'code': 'currencyLike',
                    'value': 'USD'
                }
            ]
        }
    },
    {
        id: 5, name: '2030 US Treasuries',
        bondFields: {
            endDate: '20311231',
            startDate: '20290101',
            yieldMin: 0.1,
            yieldMax: 12
        },
        filters: {
            instrument: 'BOND.GOVT',
            locations: 'BOND.GOVT.US',
            scanCode: 'HIGH_BOND_ASK_YIELD_ALL',
            secType: 'BOND',
            filters: [
                {
                    'code': 'maturityDateAbove',
                    'value': '20290101'
                },
                {
                    'code': 'maturityDateBelow',
                    'value': '20311231'
                },
                {
                    'code': 'bondAskYieldAbove',
                    'value': 0.1
                },
                {
                    'code': 'bondAskYieldBelow',
                    'value': 12
                },
                {
                    'code': 'currencyLike',
                    'value': 'USD'
                }
            ]
        }
    },
]